<template>
  <div class="wiki-detail-user">
    <div class="top">
      <router-link :to="`/user/index/${user.uid}.html`">
        <img :src="handleImgSize(user.avatar, 'list')" alt="" />
        <div class="user-infos">
          <span class="info-name">
            <span class="name">{{ user.username }}</span>
          </span>
          <span class="info-tag">
            <user-tag-group class="mL5" :user="user" />
          </span>

          <span class="article-infos">
            <span class="subscribe">
              关注:
              {{ user.subscribe_num > 1000 ? "999+" : user.subscribe_num }}
            </span>
            <span class="follow">
              粉丝:
              {{ user.follow_num > 1000 ? "999+" : user.follow_num }}
            </span>
          </span>
        </div>
      </router-link>
      <el-button
        v-if="loginUid != user.uid && needLogin"
        :class="['follow-btn', user.is_followed ? 'followed' : '']"
        icon="el-icon-plus"
        type="primary"
        @click="onFollow"
      >
        {{ user.is_followed ? $t("followed") : $t("follow") }}
      </el-button>
    </div>
    <div class="bottom" v-if="showDesc(user)">
      <div class="user-desc">
        <span>{{ user.description || "这个人很神秘，什么也没有留下~" }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// components
import UserTagGroup from "@/components/UserTag/UserTagGroup";
// api
import { apiUserAddFollow } from "@/api/userApi";

export default {
  name: "DetailUser",
  components: {
    UserTagGroup
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["loginUid"])
  },
  methods: {
    // 是否显示签名
    showDesc(user) {
      // 管理员、版主、超管
      if ([1, 2].includes(user.role_id) || user.is_super) {
        return true;
      }
      return false;
    },
    // 关注用户
    onFollow() {
      if (!this.isLogin()) {
        return false;
      }
      let params = {
        follow_uid: this.user.uid
      };
      apiUserAddFollow(params).then(res => {
        this.user.is_followed = this.user.is_followed ? 0 : 1;
        this.user.is_followed ? this.user.follow_num++ : this.user.follow_num--;
        this.emit("refresh", this.detail, this.user);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.wiki-detail-user {
  width: 300px;
  background: url("../../../../assets/images/user-card-bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 10px;
  margin-bottom: 28px;
  .top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .bottom {
    width: 100%;
    height: auto;
    background: rgba(255, 255, 255, 0.88);
    border-radius: 4px;
    border: 1px solid #b4cbeb;
    margin-top: 13px;
    padding: 8px 10px;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .user-infos {
    .info-name {
      display: flex;
      align-items: center;
    }
    .name {
      display: inline-block;
      width: 144px;
      font-size: 14px;
      font-weight: 500;
      color: #2c4252;
      line-height: 20px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .info-tag {
      margin-top: 3px;
      margin-bottom: 6px;
      /deep/ .user-tag-group {
        margin: 0;
      }
    }
  }

  .user-desc {
    font-size: 12px;
    font-weight: 400;
    color: #50606d;
    line-height: 17px;
    white-space: pre-wrap;
  }
  .follow-btn {
    width: 74px;
    height: 35px;
    margin-left: 7px;
    margin-top: 3px;
    padding: 0;
    &:hover {
      opacity: 0.9;
    }
    &.followed {
      color: #666;
      background-color: #e8e8e8;
      border-color: #e8e8e8;
    }
  }
  .name {
    color: #333;
    font-size: 14px;
    font-weight: 400;
  }
  .article-infos {
    color: #999;
    font-size: 12px;
    font-weight: 400;
    display: flex;
    gap: 9px;
  }
  a {
    display: flex;
    align-items: stretch;

    img {
      width: 40px;
      height: 40px;
      background: #f5f5f5;
      border-radius: 50%;
      object-fit: cover;
      border: 2px solid #7aa9b8;
    }

    > div {
      max-width: 300px;
      padding-left: 12px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      p {
        font-size: 11px;
        color: #2c4252;
      }

      span,
      p {
        .ellipsis;
        display: block;
      }
    }
  }
}
</style>
